import { render, staticRenderFns } from "./MoveCheckbox.vue?vue&type=template&id=122ba2de&scoped=true&"
import script from "./MoveCheckbox.vue?vue&type=script&lang=js&"
export * from "./MoveCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MoveCheckbox.vue?vue&type=style&index=0&id=122ba2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ba2de",
  null
  
)

export default component.exports